import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	methods: {
		loadStati() {
			let me = this;
			let pathResource = "/gestioneattivitastati";
			UtilityMixin.methods.loadDataResources(pathResource, {}, me.loadStatiSuccess, me.loadStatiError);
		},
		loadStatiSuccess(response) {
			let me = this;
			me.statiOptions = response.data.data.list;
		},
		loadStatiError(error) {
			console.log(error);
		},
	},
};
